<script lang="ts">
  import { Activity, type Exercise } from '@/Common/ActivityFunctions';
  import { cn } from '@/lib/utils';
  import type { TodaysActivities } from '@/Common/constants';
  import { _ } from 'svelte-i18n';
  import TodayActivity from './TodayActivity.svelte';
  import TodayForecastActivity from './TodayForecastActivity.svelte';

  export let activity: Exercise;
  export let todaysActivities: TodaysActivities;
  export let selectable: boolean = false;
  export let onSelectedChange: (selected: boolean) => void = () => {};
  // This slightly changes how the title, activity time, xss, distance, and duration are laid out
  // to put the activity time in the top right of the card (better suited for timeline view)
  export let useTimelineLayout: boolean = false;
  export let activityImageCarouselNumber: Record<string, number>;
  export let conflictNotes: string[] = [];

  let selected: boolean = false;
  $: if (!selectable) selected = false; // reset selected to false when selectable changes

  $: isHidden = Activity.isHidden(activity);
  $: isDuplicate = Activity.isDuplicate(activity);
  $: isForecastEvent = Activity.isForecastEvent(activity);

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class={cn("flex flex-row gap-2 h-max rounded-lg border border-border p-4",
  (isHidden || isDuplicate) ? 'bg-transparent border-dashed hidden-today-activity-card' : 'bg-white border-solid shadow-sm hover:shadow',
  selectable ? 'transition-all duration-150 ease-out transform-gpu will-change-transform' +
    'hover:shadow-lg hover:-translate-y-0.5 hover:bg-muted' : '',
)} on:click={() => {if (selectable) {selected = !selected; onSelectedChange(selected);}}}>
  {#if isForecastEvent}
    <TodayForecastActivity {activity} {todaysActivities} {selectable} {onSelectedChange} {useTimelineLayout} {activityImageCarouselNumber} {conflictNotes} bind:selected />
  {:else}
    <TodayActivity {activity} {todaysActivities} {selectable} {onSelectedChange} {useTimelineLayout} {activityImageCarouselNumber} bind:selected />
  {/if}
</div>

<style>
  .hidden-today-activity-card {
    background: repeating-linear-gradient(
      45deg,
      rgba(0,0,0, 0.03) 0px,
      rgba(0,0,0, 0.03) 3px,
      transparent 2px,
      transparent 8px
    );
  }
</style>
